import { alpha, styled } from '@mui/material';

export const LoadingContainerStyled = styled('div')(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: alpha(theme.palette.white.main, 0.7),
}));
